import { useRef, useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'
import type { BillingCashDashboard } from './types'

export function useBillingCash() {
  const [paymentWindowDays, setPaymentWindowDays] = useState<7 | 30>(30)
  const forceRefreshRef = useRef(false)
  const query = useQuery<BillingCashDashboard, Error>({
    queryKey: ['billing-cash', paymentWindowDays],
    queryFn: async () => {
      const params = new URLSearchParams({ paymentWindowDays: String(paymentWindowDays) })
      if (forceRefreshRef.current) params.set('refresh', 'true')
      try {
        const result = await api.get<BillingCashDashboard>(
          `/billing-cash/summary?${params.toString()}`,
        )
        return result
      } finally {
        forceRefreshRef.current = false
      }
    },
    staleTime: 60_000,
  })

  return {
    ...query,
    paymentWindowDays,
    setPaymentWindowDays,
    refresh: () => {
      forceRefreshRef.current = true
      return query.refetch()
    },
  }
}
